import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

//NPM MODULES - most added in Shared module
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MarkdownModule } from 'ngx-markdown';
import { GoogleMapsModule } from '@angular/google-maps';

//MODULES
import { AppRoutingModule } from './app-routing.module';
import { ConfirmDialogModule } from  './confirm-dialog/confirm-dialog.module';
import { SharedModule } from  './shared/shared.module';
import { SharedComponentsModule } from './shared-components/shared-components.module';

//SERVICES
import { CanDeactivateGuard } from './shared/route-guards/can-deactivate-guard.service';
import { CartService } from './shared/services/cart.service';
import { ItineraryService } from './shared/services/itinerary.service';

//COMPONENTS
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { TosComponent } from './pages/tos/tos.component';
import { AlertComponent } from './pages/alert/alert.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { GeneralErrorComponent } from './pages/general-error/general-error.component';
import { CustomValidationService } from './shared/services/custom-validation.service';
import { MsalInterceptor, MsalModule } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { apiConfig, b2cPolicies } from './auth/b2c-config';
import { UnifiedSignUpSignInComponent } from './azureb2c/unified-sign-up-sign-in/unified-sign-up-sign-in.component';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { GlobalWatchService } from './shared/services/global-watch.service';
import { AscediaDesignSystemModule } from 'ascedia-design-system';


const isIE = typeof window !== "undefined" && (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1);

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}


@NgModule({
	declarations: [
		AppComponent,
		AlertComponent,
		HomeComponent,
		NotFoundComponent,
		PrivacyComponent,
		TosComponent,
		ForbiddenComponent,
		GeneralErrorComponent,
		UnifiedSignUpSignInComponent
		//PIPES
		//DateMatchPipe
	],
	imports: [
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		AppRoutingModule,
		GoogleMapsModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		BsDatepickerModule.forRoot(),
		SharedModule,
		SharedComponentsModule,
		ConfirmDialogModule,
		AscediaDesignSystemModule,
		MarkdownModule.forRoot(),   
		MsalModule.forRoot( new PublicClientApplication({
			auth: {
			  clientId: b2cPolicies.clientId,
			  authority: b2cPolicies.authorities.signUpSignIn.authority,
			  redirectUri: '/',
			  postLogoutRedirectUri: '/',
			  knownAuthorities: [b2cPolicies.authorityDomain]
			},
			cache: {
			  cacheLocation: BrowserCacheLocation.LocalStorage,
			  storeAuthStateInCookie: isIE
			},
			system: {
				loggerOptions: {
				  loggerCallback,
				  logLevel: LogLevel.Error,
				  piiLoggingEnabled: true
				}
			}
		  }), {
			interactionType: InteractionType.Redirect,		
			authRequest: {
				scopes: [...apiConfig.scopes],
			},
			loginFailedRoute: b2cPolicies.loginFailedPath
		  }, {
			interactionType: InteractionType.Redirect,
			protectedResourceMap: new Map([
			  ['https://graph.microsoft.com/v1.0/me', ['user.read']],
			  ...apiConfig.protectedResources
			])
		  })
	],
	providers: [
		CanDeactivateGuard,
		CartService,
		ItineraryService,
		CustomValidationService,
		GlobalWatchService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true
		},
		[{
			provide: APP_BASE_HREF, useValue: environment.baseHref
		}]
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(){}
}
